import { withStyles } from "@material-ui/core/styles";
import React from "react";
import {
  EditController,
  SelectInput,
  NumberInput,
  ListButton,
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CustomSimpleForm from "../customise/CustomSimpleForm";
import CustomToolbar from "../customise/CustomToolbar";
import { SLA_ITEM_SHOW } from "./item_show";
import ChevronLeft from "@material-ui/icons/ChevronLeft";

const editStyles = {
  root: { display: "flex", alignItems: "flex-start", width: "100%" },
  form: { flexGrow: 9 },
};

const ShowListAction = ({ basePath, size, title = "SLA Item Details" }) => (
  <Grid container spacing={0}>
    <Grid item xs={5}>
      <span
        style={{
          float: "left",
          marginLeft: "20px",
          marginTop: "20px",
          fontWeight: "bold",
          fontSize: "1.3em",
        }}
      >
        {title}
      </span>
    </Grid>
    <Grid item xs={5}></Grid>
    <Grid item xs={2}>
      <span
        style={{ float: "right", marginRight: "20px", marginBottom: "30px" }}
      >
        <ListButton
          basePath={basePath}
          label="Back"
          icon={<ChevronLeft />}
          size={size}
        />
      </span>
    </Grid>
  </Grid>
);

class SLAsEditToStyle extends React.Component {
  render() {
    const FormDiv = withStyles(editStyles)(
      ({ children, classes, actions, ...props }) => {
        return (
          <div className={classes.root}>
            <div className={classes.form}>
              {actions}
              <SLA_ITEM_SHOW {...props} />
              <br />
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <SelectInput
                    label="Pass/Fail"
                    source="state"
                    choices={[
                      { id: "Pass", name: "Pass" },
                      { id: "1st Failure", name: "1st Failure" },
                      { id: "2nd Failure", name: "2nd Failure" },
                      { id: "3rd Failure", name: "3rd Failure" },
                    ]}
                  />
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={2}>
                  <NumberInput source="score" disabled />
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={2}>
                  <NumberInput source="penalty" disabled />
                </Grid>
              </Grid>
            </div>
          </div>
        );
      }
    );

    return (
      <EditController {...this.props} undoable={false}>
        {({ resource, record, redirect, save, basePath, version, ...rest }) => {
          return (
            <div>
              <Card>
                {record && (
                  <CustomSimpleForm
                    toolbar={
                      <CustomToolbar allowDelete={false} editable={true} />
                    }
                    basePath={basePath}
                    redirect={redirect}
                    resource={resource}
                    record={record}
                    save={save}
                    version={version}
                  >
                    <FormDiv
                      record={record}
                      actions={
                        <ShowListAction basePath={basePath} size="large" />
                      }
                    />
                  </CustomSimpleForm>
                )}
              </Card>
            </div>
          );
        }}
      </EditController>
    );
  }
}

const SLAsEdit = withStyles(editStyles)(SLAsEditToStyle);
export default SLAsEdit;

export { SLAsEdit };
